import React, { Component } from 'react';
import { Banner } from '../../Components'
import './View.scss'
import FormInput from '../../Components/FormInput'
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject('store')
@observer    
class View extends Component {

    @observable error = false
    @observable newFields = false

    componentDidMount() {
        if (!this.props.store.username && !this.props.store.password && !this.props.store.doctor.hodby_id) {
            this.props.history.push('/update')
        } else {
            this.props.store.api.post('/update/doctor', { hodby_id: this.props.store.username, hodby_password: this.props.store.password })
                .then(({ data }) => {
                    localStorage.setItem("update_doctor", JSON.stringify(data))
                    this.props.store.doctor = data
                })
                .catch(err => { console.log(err); })
        }
    }

    onSubmit = async () => {
        this.newFields = false
        console.log('submittin')
        if (this.props.store.doctor.confirmation && this.props.store.doctor.personWhoCompletedForm) {
            const submitting = await this.props.store.submitUpdate()
            if (submitting) {
                this.props.history.push('/update/complete')
            } else {
                this.error = true
            } 
        } else {
            this.newFields = true
        }
        
    }

    hasChanged = (attr, value) => {
        if (!this.props.store.doctor.changesMade) {
            this.props.store.doctor.changesMade = {}
        }
        this.props.store.doctor.changesMade[attr] = value
    }

    render() {
        const { doctor } = this.props.store
        return (
            <div className="update-page">
                <Banner title="Update Your Record" subtitle="Fill out the following details below." />
                
                <div className="container page">

                    <div className="img" style={{backgroundImage: `url(${require('./doctor.png')})`}}>
                        
                    </div>
                    
                    <h2>{doctor.fname} {doctor.lname}</h2>
                    <h3>{doctor.field && doctor.field.title}</h3>
                    <h5>{doctor.interests && doctor.interests.map(interest => `${interest.title}, `)}</h5>

                    <hr />

                    <div className="row">
                        <div className="col-md-6">

                        <h3 className="m-b-1">Personal Details</h3>
                            <Row 
                                title="Title" 
                                placeholder="Dr, Prof, Mr, Mrs, Ms, Miss etc" 
                                value={doctor.title} 
                                onChange={e => { doctor.title = e.target.value;this.hasChanged('doctor.title', e.target.value)}} 
                                type="select" 
                                values={["Dr", "Prof", "Mr", "Mrs", "Ms", "Miss" ]} />
                            <Row 
                                title="First name" 
                                value={doctor.fname} 
                                onChange={e=>{doctor.fname = e.target.value;this.hasChanged('doctor.fname', e.target.value)}}  />
                            <Row 
                                title="Last name" 
                                value={doctor.lname} 
                                onChange={e => { doctor.lname = e.target.value;;this.hasChanged('doctor.lname', e.target.value)}} />
                            <Row 
                                title="Preferred Listing" 
                                placeholder="Your name as you want it to appear (e.g. Dr Brian Hopkins)" 
                                value={doctor.othername} 
                                onChange={e => { doctor.othername = e.target.value;;this.hasChanged('doctor.othername', e.target.value)}}  />
                            <Row 
                                title="Gender" 
                                value={doctor.gender} 
                                onChange={e=>{doctor.gender = e.target.value;this.hasChanged('doctor.gender', e.target.value)}} 
                                type="select" 
                                values={["Female", "Male", ]}  />
                            <Row 
                                title="About" 
                                value={doctor.about} 
								onChange={e => { doctor.about = e.target.value; this.hasChanged('doctor.about', e.target.value) }} />
							
							<Row 
                                title="College" 
                                value={doctor.college} 
								onChange={e => { doctor.college = e.target.value; this.hasChanged('doctor.college', e.target.value) }} />
							

                            <Row 
                                title="Qualifications" 
                                value={doctor.qualification} 
                                onChange={e => {doctor.qualification = e.target.value;this.hasChanged('doctor.qualitifcation', e.target.value)}} />
                            
                                <h3 className="m-b-1">Contact Details</h3>
                                <Row 
                                    title="Email" 
                                    placeholder="email@address.com"
                                    value={doctor.email} 
                                    onChange={e=>{doctor.email = e.target.value;this.hasChanged('doctor.email', e.target.value)}}   />
                                <Row 
                                    title="Website" 
                                    placeholder="http://www..."
                                    value={doctor.website} 
                                    onChange={e=>{doctor.website = e.target.value;this.hasChanged('doctor.website', e.target.value)}}   />
                                <Row 
                                    title="Phone" 
                                    placeholder="(08) 4000 0000" 
                                    value={doctor.phone} 
                                    onChange={e=>{doctor.phone = e.target.value;this.hasChanged('doctor.phone', e.target.value)}}   />
                                <Row 
                                    title="Fax" 
                                    placeholder="(08) 4000 0000" 
                                    value={doctor.fax} 
                                    onChange={e=>{doctor.fax = e.target.value;this.hasChanged('doctor.fax', e.target.value)}}   />
                                <Row 
                                    title="Mobile" 
                                    placeholder="040 000 000" 
                                    desc="Only registered practitioners will be able to see your mobile number. Listing your mobile so that referrers can contact you can improve your relationship with referrers. Please specify how you would like your mobile to be used:" 
                                    value={doctor.mobile} 
                                    onChange={e=>{doctor.mobile = e.target.value;;this.hasChanged('doctor.mobile', e.target.value)}}   />
                                <Row 
                                    title="Mobile Preference"  
                                    type="select" 
                                    value={doctor.preferred} 
                                    onChange={e=>{doctor.preferred = e.target.value;;this.hasChanged('doctor.preferred', e.target.value)}} 
                                    values={["Referrals and questions are welcome.", "For Emergencies only.", "Do not list my mobile number"]} />
                                <Row 
                                    title="Email Preference"  
                                    type="select" 
                                    value={doctor.preferredMobile} 
                                    onChange={e=>{doctor.preferredMobile = e.target.value;this.hasChanged('doctor.preferredMobile', e.target.value)}} 
                                    values={["List my email.", "Don't list my email"]} />
                                 <Row 
                                    title="Healthlink" 
                                    placeholder="Healthlink" 
                                    value={doctor.healthlink} 
                                    onChange={e=>{doctor.healthlink = e.target.value;;this.hasChanged('doctor.healthlink', e.target.value)}}   />
                            
                            
                        </div>

                        <div className="col-md-6">
                            <h3 className="m-b-1">Speciality</h3>
                                <Row 
                                    title="Specialisation" 
                                    value={doctor.field.title} 
                                    onChange={e=>{doctor.field.title = e.target.value;this.hasChanged('doctor.field.title', e.target.value)}} />

                                {doctor.fields && doctor.fields.map((theField, index) =>
                                    <Row 
                                        title="Secondary" 
                                        value={theField.title} 
                                        onDelete={()=>doctor.fields.splice(index,1)}
                                        onChange={e=>{theField.title = e.target.value;this.hasChanged(`doctor.fields.${index}`, e.target.value)}} />)}

                                <div className="btn" onClick={()=>doctor.fields.push({ title: ""})}>Add Speciality</div>
                                
                            <h3 className="m-b-1 m-t-1">Special Interests</h3>

                                {doctor.interests && doctor.interests.map((theInterest, index) =>
                                    <Row 
                                        title={`Interest`}
                                        value={theInterest.title} 
                                        onDelete={()=>doctor.interests.splice(index,1)}
                                        onChange={e=>{theInterest.title = e.target.value;this.hasChanged(`doctor.specialinterests.${index}`, e.target.value)}} />)}    

                                <div className="btn" onClick={()=>doctor.interests.push({ title: ""})}>Add Special Interest</div>
                        </div>
                    </div>

                    <div className="row m-t-1">

                    <div className="col-md-6">
                            <h3 className="m-b-1">Types of Patients</h3>
                                <Row 
                                    title="Do you see children?" 
                                    value={doctor.children} 
                                    onChange={e=>{doctor.children = e.target.value;;this.hasChanged('doctor.children', e.target.value)}} 
                                    type="select" 
                                    values={["Prefer not to say","Yes", "No" ]} />

                            <h4 className="m-b-1">Will you see patients who are funded through:</h4>

                                <Row 
                                    title="Worker's Compensation" 
                                    value={doctor.wc} 
                                    onChange={e=>{doctor.wc = e.target.value;this.hasChanged('doctor.wc', e.target.value)}}  
                                    type="select" 
                                    values={["Prefer not to say","Yes", "No" ]} />
                                <Row 
                                    title="DVA" 
                                    value={doctor.dva} 
                                    onChange={e=>{doctor.dva = e.target.value;this.hasChanged('doctor.dva', e.target.value)}} 
                                    type="select" 
                                    values={["Prefer not to say","Yes", "No" ]} />
                                <Row 
                                    title="MVIT (Motor Vehicles)" 
                                    value={doctor.mvit} 
                                    onChange={e=>{doctor.mvit = e.target.value;this.hasChanged('doctor.mvit', e.target.value)}} 
                                    type="select" 
                                    values={["Prefer not to say", "Yes", "No"]} />
                            
                            
                            
                            

                        </div>
                            <div className="col-md-6">
                            <h3>Languages</h3>
                                    <p className="m-b-1 m-t-1">Do you speak additional languages.</p>
                            
                            {doctor.languages && doctor.languages.map((theLanguage, index) =>
                                <Row 
                                    title={`Language`}
                                    value={theLanguage} 
                                    onDelete={()=>doctor.languages.splice(index,1)}
                                    onChange={e => {doctor.languages[index] = e.target.value;this.hasChanged(`doctor.languages.${index}`, e.target.value)}} />)}  
                            
                            <div className="btn" onClick={() => doctor.languages.push("")}>Add Language</div>
                        </div>

                    </div>

                    <div className="row m-t-2">
                        <div className="col-md-6">
                        <h3 className="">Primary Clinic</h3>
                            {doctor.clinic && <div>
                                
                                <h4 className="m-b-1 m-t-1">{doctor.clinic.name} </h4>
                                <Row 
                                    title={`Clinic`}
                                    value={doctor.clinic.name} 
                                    onChange={e => {doctor.clinic.name = e.target.value;this.hasChanged('doctor.clinic.name', e.target.value)}} /> 

                                <Row 
                                    title={`Alternative Name`}
                                    value={doctor.clinic.othername} 
                                    onChange={e => {doctor.clinic.othername = e.target.value;this.hasChanged('doctor.clinic.othername', e.target.value)}} /> 

                                <Row 
                                    title={`Address`}
                                    value={doctor.clinic.address} 
                                    onChange={e => {doctor.clinic.address = e.target.value;this.hasChanged('doctor.clinic.address', e.target.value)}} />
                                
                                <Row 
                                    title="Email" 
                                    placeholder="email@address.com"
                                    value={doctor.clinic.email} 
                                    onChange={e=>{doctor.clinic.email = e.target.value;this.hasChanged('doctor.clinic.email', e.target.value)}}   />
                                <Row 
                                    title="Website" 
                                    placeholder="http://www..."
                                    value={doctor.clinic.website} 
                                    onChange={e=>{doctor.clinic.website = e.target.value;this.hasChanged('doctor.clinic.website', e.target.value)}}   />
                                <Row 
                                    title="Phone" 
                                    placeholder="(08) 4000 0000" 
                                    value={doctor.clinic.phone} 
                                    onChange={e=>{doctor.clinic.phone = e.target.value;this.hasChanged('doctor.clinic.phone', e.target.value)}}   />
                                <Row 
                                    title="Fax" 
                                    placeholder="(08) 4000 0000" 
                                    value={doctor.clinic.fax} 
                                    onChange={e=>{doctor.clinic.fax = e.target.value;this.hasChanged('doctor.clinic.fax', e.target.value)}}   />

                            </div>}
                        
                            <h3 className="m-b-1">Secondary Clinics</h3>
                            {doctor.clinics && doctor.clinics.map((theClinic, index) =>
                            
                                <div>
                                    <div className="btn secondary float-right xs" onClick={() => doctor.clinics.splice(index, 1)}>x</div>
                                    <h4 className="m-b-1 m-t-1">{theClinic.name || "Clinic"}</h4>
                                <Row 
                                    title={`Clinic`}
                                    value={theClinic.name} 
                                    onChange={e => {theClinic.name = e.target.value;this.hasChanged(`doctor.clinic.${index}.name`, e.target.value)}}
                                /> 

                                <Row 
                                    title={`Alternative Name`}
                                    value={theClinic.othername} 
                                    onChange={e => {theClinic.othername = e.target.value;this.hasChanged(`doctor.clinic.${index}.othername`, e.target.value)}} /> 

                                <Row 
                                    title={`Address`}
                                    value={theClinic.address} 
                                    onChange={e => {theClinic.address = e.target.value;;this.hasChanged(`doctor.clinic.${index}.address`, e.target.value)}} />
                                
                                <Row 
                                    title="Email" 
                                    placeholder="email@address.com"
                                    value={theClinic.email} 
                                    onChange={e=>{theClinic.email = e.target.value;;this.hasChanged(`doctor.clinic.${index}.email`, e.target.value)}}   />
                                <Row 
                                    title="Website" 
                                    placeholder="http://www..."
                                    value={theClinic.website} 
                                    onChange={e=>{theClinic.website = e.target.value;;this.hasChanged(`doctor.clinic.${index}.website`, e.target.value)}}   />
                                <Row 
                                    title="Phone" 
                                    placeholder="(08) 4000 0000" 
                                    value={theClinic.phone} 
                                    onChange={e=>{theClinic.phone = e.target.value;;this.hasChanged(`doctor.clinic.${index}.phone`, e.target.value)}}   />
                                <Row 
                                    title="Fax" 
                                    placeholder="(08) 4000 0000" 
                                    value={theClinic.fax} 
                                    onChange={e=>{theClinic.fax = e.target.value;;this.hasChanged(`doctor.clinic.${index}.fax`, e.target.value)}}   />
                                </div>    
                                
                            )}  
                            
                            <div className="btn" onClick={() => doctor.clinics.push({
                                name: "", othername: "", phone: "", fax: "", email: "",website:"",address:""
                            })}>Add Clinic</div>
                        </div>

                        <div className="col-md-6">

                        <hr />
                            
                            <h3 className="m-b-1">Hospitals (Public, Private)</h3>
                            {doctor.hospitals && doctor.hospitals.map((theHospital, index) =>
                            
                                <div>
                                    <div className="btn secondary float-right xs" onClick={() => doctor.hospitals.splice(index, 1)}>x</div>
                                    <h4 className="m-b-1 m-t-1">{theHospital.name || "Hospital"}</h4>
                                <Row 
                                    title={`Hospital`}
                                    value={theHospital.name} 
                                    onChange={e => {theHospital.name = e.target.value;this.hasChanged(`doctor.hospitals.${index}.name`, e.target.value)}}
                                /> 

                                <Row 
                                    title={`Alternative Name`}
                                    value={theHospital.othername} 
                                    onChange={e => {theHospital.othername = e.target.value;this.hasChanged(`doctor.hospitals.${index}.othername`, e.target.value)}} /> 

                                <Row 
                                    title={`Address`}
                                    value={theHospital.address} 
                                    onChange={e => {theHospital.address = e.target.value;this.hasChanged(`doctor.hospitals.${index}.address`, e.target.value)}} />
                                
                                <Row 
                                    title="Email" 
                                    placeholder="email@address.com"
                                    value={theHospital.email} 
                                    onChange={e=>{theHospital.email = e.target.value;;this.hasChanged(`doctor.hospitals.${index}.email`, e.target.value)}}   />
                                <Row 
                                    title="Website" 
                                    placeholder="http://www..."
                                    value={theHospital.website} 
                                    onChange={e=>{theHospital.website = e.target.value;this.hasChanged(`doctor.hospitals.${index}.website`, e.target.value)}}   />
                                <Row 
                                    title="Phone" 
                                    placeholder="(08) 4000 0000" 
                                    value={theHospital.phone} 
                                    onChange={e=>{theHospital.phone = e.target.value;this.hasChanged(`doctor.hospitals.${index}.phone`, e.target.value)}}   />
                                <Row 
                                    title="Fax" 
                                    placeholder="(08) 4000 0000" 
                                    value={theHospital.fax} 
                                    onChange={e=>theHospital.fax = e.target.value}   />
                                </div>    
                                
                            )}  
                            
                            <div className="btn" onClick={() => doctor.hospitals.push({
                                name: "", othername: "", phone: "", fax: "", email: "",website:"",address:""
                            })}>Add Hospital Location</div>

                        </div>
                    </div>

                    <hr/>
                    <h3 className="m-b-1">Billing and Waiting List</h3>

                    <div className="row">
                        <div className="col-md-6">
                            <Row 
                                title="Standard Consult Fee" 
                                placeholder="$" 
                                value={doctor.initialCost} 
                                onChange={e => { doctor.initialCost = e.target.value;; this.hasChanged('doctor.initialCost', e.target.value) }}
                            />
                          <Row 
                                title="Billing Policy" 
                                value={doctor.patientEligibility} 
                                type="select" 
                                values={[
                                    "All patients privately billed",
                                    "Reduced gap for healthcare card",
                                    "Reduced gap for pensioners",
                                    "Reduced gap for children",
                                    "Bulk bill healthcare card",
                                    "Bulk bill pensioners",
                                    "Bulk bill children",
                                    "All patients bulk billed",
                                    "Prefer not to say"]}
                                onChange={e => { doctor.patientEligibility = e.target.value;; this.hasChanged('doctor.patientEligibility', e.target.value) }}
                            />
                            <Row 
                                title="Display Preference (billing)" 
                                value={doctor.billingPreferences} 
                                type="select" 
                                values={[
                                    "Show billing details",
                                    "Only show the consult fee",
                                    "Only show the billing policy",
                                    "Do not show billing details"
                                ]}
                                onChange={e => { doctor.billingPreferences = e.target.value;; this.hasChanged('doctor.billingPreferences', e.target.value) }}
                            />
                            <Row 
                                title="Non Urgent Wait Time" 
                                placeholder="$" 
                                value={doctor.averageWaitTime} 
                                type="select" 
                                values={[
                                    "Less than 3 months",
                                    "4-6 months",
                                    "7-12 months",
                                    "More than 12 months"
                                ]}
                                onChange={e => { doctor.averageWaitTime = e.target.value;; this.hasChanged('doctor.averageWaitTime', e.target.value) }}
                            />
                            <Row 
                                title="Display Preference (wait)" 
                                value={doctor.waitTimePreferences} 
                                type="select" 
                                values={[
                                    "Show wait time",
                                    "Do not show wait time"
                                ]} 
                                onChange={e => { doctor.waitTimePreferences = e.target.value;; this.hasChanged('doctor.waitTimePreferences', e.target.value) }}
                            />
                        </div>
                    </div>
                        
                    <hr />
                    
                    <h3>Confirmation</h3>
                    <div className={`${this.newFields && "error"}`}>

                    
                    <input type="checkbox" style={{ float: 'left', padding: 5,margin: 5,}} value={doctor.confirmation} onChange={e => { doctor.confirmation = e.target.value;this.hasChanged('doctor.confirmation', e.target.value) }}  />
                     <h5> Tick this box to acknowledge that you have provided truthful and accurate information that is representative of the qualifications and skills of the individual listed.</h5>
                     <hr/>
                    <input type="text" className="input" value={doctor.personWhoCompletedForm} onChange={e => { doctor.personWhoCompletedForm = e.target.value;this.hasChanged('doctor.personWhoCompletedForm', e.target.value) }}  />
                        <h5>Fill your name here as acknowledgement of the above and the Terms of Service.</h5>
                        
                        </div>
                    <hr/>
                    <h5>Thank you for reviewing the details. Please make sure you have checked everything is correct as it will be part of the publication of the book as well as the online directory for the next year.</h5>
                    <hr/>

                    <h4 className="btn secondary" onClick={this.onSubmit}>Submit Updates</h4>

                    


                </div>

            </div>
        );
    }
}

// Add this≠≠≠===±±±
// optins = [
//     "listing correcto",
//     "remove my listing",
//     "if not correct, i have fixed it"
// ]



const Row = (props) => 
    <div>
        <div className="row">
            <div className="col-md-5">
                {props.onDelete && <div className="btn secondary float-right xs" onClick={props.onDelete}>x</div>}
                    <h5>{props.title}</h5>
            </div>
            <div className="col-md-7">
                <FormInput {...props} />
            </div>
            {props.desc && <div className="col-md-12">
                <p className="m-t-1">{props.desc}</p>
            </div>}
        </div>
        <hr/>          
    </div> 

export default View;


// WEBPACK FOOTER //
// ./src/Containers/Update/View.js